import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UnitPreferenceProperty, UnitPreferenceRow } from 'src/app/models/accountSettings.model';
import { UserProfile } from 'src/app/models/userProfile.model';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

@Component({
    standalone: false,
    selector: 'app-account-units-tab',
    templateUrl: './account-units-tab.component.html',
    styleUrls: ['./account-units-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountUnitsTabComponent {
    @Input() units: UnitPreferenceRow[] = [];
    @Input({ required: true }) profile!: UserProfile;
    @Output() changed = new EventEmitter<Partial<UserProfile>>();

    readonly trackByIndex = trackByIndex;

    onUnitChange(property: UnitPreferenceProperty, value: number | string): void {
        const patch: Partial<UserProfile> = {};
        patch[property] = Number(value);
        this.changed.emit(patch);
    }
}
